import { ProgressBarChart } from '@seek/charts';
import { useTranslations } from '@vocab/react';
import { Box, Text, useColor } from 'braid-design-system';
import { useMemo } from 'react';

import translations from './.vocab';

const useProgressPercentage = ({
  currentQuestion,
  totalQuestions,
}: ProgressBarProps) =>
  useMemo(
    () => Math.min(((currentQuestion - 1) / totalQuestions) * 100, 100),
    [currentQuestion, totalQuestions],
  );

export const useProgressPercentageForTest = useProgressPercentage;

interface ProgressBarProps {
  currentQuestion: number;
  totalQuestions: number;
}

export const ProgressBar = ({
  currentQuestion,
  totalQuestions,
}: ProgressBarProps) => {
  const { t } = useTranslations(translations);
  const color = useColor();
  const progressPercentage = useProgressPercentage({
    currentQuestion,
    totalQuestions,
  });

  return (
    <>
      <Box display="flex" justifyContent="spaceBetween">
        <Text size="xsmall" tone="secondary">
          {t('Question {currentQuestion} of {totalQuestions}', {
            currentQuestion: currentQuestion.toString(),
            totalQuestions: totalQuestions.toString(),
          })}
        </Text>
        <Text size="xsmall" tone="secondary" />
      </Box>
      <ProgressBarChart
        color={color.background.brandAccent}
        progress={progressPercentage}
      />
    </>
  );
};
